<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>业务渠道</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 校长视图 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 查询条件区域 -->
      <div class="search-container">
        <div class="search-header">
          <div class="search-title">
            <i class="el-icon-search"></i>
            <span>查询条件</span>
          </div>
          <div class="toggle-button" @click="isCollapsed = !isCollapsed">
            <span>{{ isCollapsed ? '展开' : '收起' }}</span>
            <i :class="collapseIcon" class="el-icon--right"></i>
          </div>
        </div>

        <el-collapse-transition>
          <div v-show="!isCollapsed" class="search-content">
            <el-form
                    size="mini"
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="100px"
                    autocomplete="on"
                    class="search-form"
            >
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="搜索关键字" class="form-item-custom">
                    <el-input
                            @input="goSearch"
                            v-model="searchForm.keyword"
                            placeholder="请输入商户名/手机号/地址"
                            clearable
                            type="text"
                            prefix-icon="el-icon-search"
                            class="search-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商编号" class="form-item-custom">
                    <el-input
                            @input="goSearch"
                            v-model="searchForm.proxy_sn"
                            placeholder="请输入代理商编号"
                            clearable
                            type="text"
                            prefix-icon="el-icon-search"
                            class="search-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="类型" class="form-item-custom">
                    <el-select
                            v-model="searchForm.type_id"
                            placeholder="请选择类型"
                            clearable
                            class="search-select"
                            @change="goSearch"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="加油站分润" value="1"></el-option>
                      <el-option label="运企分润" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>


              </el-row>

              <el-row :gutter="24" style="margin-top: 10px;">
                <el-col :span="16">
                    <el-form-item label="状态" class="form-item-custom">
                      <el-select
                              @change="statusChange"
                              clearable
                              v-model="searchForm.status"
                              placeholder="请选择状态"
                              class="search-select"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                      </el-select>
                    </el-form-item>

                  <el-form-item label="创建时间" class="form-item-custom">
                    <el-date-picker
                            @change="changeTime"
                            v-model="searchForm.start_end_date"
                            type="daterange"
                            align="right"
                            size="mini"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="startEndOptions"
                            class="date-picker"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="8" class="search-actions">
                  <el-button
                          @click="resetSearch"
                          size="mini"
                          icon="el-icon-refresh"
                          class="reset-btn"
                  >
                    重置
                  </el-button>
                  <el-button
                          @click="goSearch"
                          type="primary"
                          size="mini"
                          icon="el-icon-search"
                          class="search-btn"
                  >
                    查询
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>

      <!-- 操作按钮区域 -->
      <div class="action-container">
        <div class="action-buttons">
          <el-button @click="goAdd" type="primary" size="mini" icon="el-icon-plus">添加</el-button>
          <el-button
                  @click="batchDelete"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  :disabled="multipleSelection.length === 0"
          >
            批量删除
          </el-button>
          <el-button @click="goExcel" size="mini" icon="el-icon-download">导出</el-button>
        </div>

        <div class="selection-info" v-if="multipleSelection.length > 0">
          <el-tag type="info" size="small">
            <i class="el-icon-check"></i>
            已选择 {{multipleSelection.length}} 项
          </el-tag>
        </div>
      </div>

      <!-- 表格区域 -->
      <el-table
              :data="tableLoadData"
              stripe
              size="mini"
              border
              ref="multipleTable"
              @selection-change="handleSelectionChange"
              class="data-table"
      >
        <!-- 表格列保持不变 -->

        <el-table-column :index="indexMethod" fixed="left" type="index" label="序号" width="50"></el-table-column>

        <el-table-column fixed="left" label="所属商家" width="100">
          <template slot-scope="{row}">
            <span>{{row.shop?row.shop.name:''}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="left" label="业务员编码" width="100">
          <template slot-scope="{row}">
            <span>{{row.proxy_sn}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="left" label="比例%" width="100">
          <template slot-scope="{row}">
            <span>{{removeExtraZeros(row.rate)}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="left" label="分润类型" width="160">
          <template slot-scope="{row}">
            <el-tag
                    :type="row.balanceparams&&row.balanceparams.type_id === 1 ? 'success' : 'warning'"
                    size="mini"
            >
              {{row.balanceparams&&row.balanceparams.type_id==1?"加油站分润":(row.balanceparams&&row.balanceparams.type_id==2?"运企分润":"")}}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag
                    :type="row.status === 1 ? 'success' : 'danger'"
                    size="mini"
            >
              {{row.status === 1 ? '启用' : '禁用'}}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="150">
          <template slot-scope="{row}">
            <span>{{row.add_time | timeFormat}}</span>
          </template>
        </el-table-column>

        <el-table-column label="备注" min-width="120" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.remark || '--'}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="{row, $index}">
            <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-edit"
                    @click="goEdit(row, $index)"
            >
              编辑
            </el-button>
            <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-delete"
                    @click="goDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
              style="margin-top: 20px; text-align: right"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              class="pagination"
      />
    </el-card>

    <!-- 新增/编辑分润设置弹窗 -->
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="handleClose">

      <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-width="120px"
              size="mini">

        <el-form-item label="所属商家" prop="shop_id">
          <el-select
                  v-model="form.shop_id"
                  placeholder="请输入商户名称、区域或手机号搜索"
                  style="width: 100%"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="remoteSearchShop"
                  :loading="shopLoading"
                  @focus="handleShopFocus"
                  @change="handleShopChange"
                  clearable>
            <el-option
                    v-for="shop in shopList"
                    :key="shop.id"
                    :label="shop.name"
                    :value="shop.id">
              <!-- 自定义选项内容 -->
              <div class="shop-option">
                <div class="shop-main-info">
                  <span class="shop-name">{{ shop.name }}</span>
                  <el-tag v-if="shop.status === 1" size="mini" type="success">正常</el-tag>
                  <el-tag v-else size="mini" type="danger">禁用</el-tag>
                </div>
                <div class="shop-detail-info">
          <span class="shop-region">
            <i class="el-icon-location-outline"></i>
            {{ shop.province?shop.province.region_name:'' }}{{ shop.city?shop.city.region_name : '' }}{{ shop.district?shop.district.region_name :'' }}
          </span>
                  <span class="shop-mobile">
            <i class="el-icon-phone"></i>
            {{ shop.mobile || shop.telephone || '暂无' }}
          </span>
                </div>
                <div v-if="shop.address" class="shop-address">
                  <i class="el-icon-office-building"></i>
                  {{ shop.address }}
                </div>
              </div>
            </el-option>

            <!-- 无数据时显示 -->
            <div v-if="shopList.length === 0 && !shopLoading" slot="empty" class="empty-shop">
              <i class="el-icon-search" style="font-size: 16px; color: #909399;"></i>
              <span style="margin-left: 8px; color: #909399;">暂无数据</span>
            </div>
          </el-select>

          <!-- 选中后的商户信息展示 -->
          <div v-if="selectedShopInfo" class="selected-shop-info">
            <el-card shadow="never" style="margin-top: 8px;">
              <div class="selected-shop-content">
                <div class="selected-shop-header">
                  <span class="selected-shop-name">{{ selectedShopInfo.name }}</span>
                  <el-tag
                          :type="selectedShopInfo.status === 1 ? 'success' : 'danger'"
                          size="mini">
                    {{ selectedShopInfo.status === 1 ? '正常营业' : '已禁用' }}
                  </el-tag>
                </div>
                <div class="selected-shop-details">
                  <div class="detail-item">
                    <i class="el-icon-location-outline"></i>
                    <span>区域: {{ selectedShopInfo.province?selectedShopInfo.province.region_name : '' }}{{ selectedShopInfo.city?selectedShopInfo.city.region_name : '' }}{{ selectedShopInfo.district?selectedShopInfo.district.region_name : '' }}</span>
                  </div>
                  <div class="detail-item">
                    <i class="el-icon-phone"></i>
                    <span>电话: {{ selectedShopInfo.mobile || selectedShopInfo.telephone || '暂无' }}</span>
                  </div>
                  <div v-if="selectedShopInfo.address" class="detail-item">
                    <i class="el-icon-office-building"></i>
                    <span>地址: {{ selectedShopInfo.address }}</span>
                  </div>
                  <div v-if="selectedShopInfo.cont_name" class="detail-item">
                    <i class="el-icon-user"></i>
                    <span>联系人: {{ selectedShopInfo.cont_name }}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-form-item>
        <el-form-item v-if="selectedShopInfo&&paramsList.length>0" label="分润类型" prop="balance_params_id">
          <el-radio-group v-model="form.balance_params_id">
            <el-radio :label="item.id" v-bind:key="index" v-for="(item,index) in paramsList">{{item.type_id==1?"加油张分润":(item.type_id==2?"运企分润":'')}}</el-radio>

          </el-radio-group>
        </el-form-item>
        <el-form-item prop="proxy_sn" label="业务编码">
          <el-input
                  v-model="form.proxy_sn"
                  placeholder="请输入业务编码"
                  maxlength="50"
                  show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item label="分润比例" prop="rate">
          <el-input
                  v-model="form.rate"
                  placeholder="请输入分润比例"
                  type="number"
                  min="0"
                  max="100"
                  step="0.01">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>



        <el-form-item label="状态" prop="status">
          <el-switch
                  v-model="form.status"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="启用"
                  inactive-text="禁用">
          </el-switch>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
                  type="textarea"
                  :rows="3"
                  v-model="form.remark"
                  placeholder="请输入备注信息"
                  maxlength="200"
                  show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button
                type="primary"
                @click="submitForm"
                :loading="submitLoading"
                size="mini">
          确 定
        </el-button>
      </div>
    </el-dialog>




  </div>
</template>

<script>

  import moment from "moment";
  export default {
    name: "shopBalanceParamsList",
    components: {

    },
    data() {
      return {

        // 商户搜索相关
        shopLoading: false,
        shopList: [],
        selectedShopInfo: null,
        searchTimer: null,

        // 远程搜索配置
        searchConfig: {
          keyword: '',
          page: 1,
          pageSize: 20,
          hasMore: true,

        },
        // 新增数据
        dialogVisible: false,
        dialogTitle: '新增分润设置',
        submitLoading: false,
        form: {
          id: '',
          shop_id: '',
          name: '',
          rate: '',
          type_id:'',
          balance_params_id:'',
          status: 1,
          remark: '',
          proxy_sn:''
        },
        rules: {
          shop_id: [
            { required: true, message: '请选择商家', trigger: 'change' }
          ],
          proxy_sn: [
            { required: true, message: '请输入业务编码', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          rate: [
            { required: true, message: '请输入分润比例', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value === '') {
                  callback(new Error('请输入分润比例'));
                } else if (parseFloat(value) < 0) {
                  callback(new Error('分润比例不能小于0'));
                } else if (parseFloat(value) > 100) {
                  callback(new Error('分润比例不能大于100'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          balance_params_id: [
            { required: true, message: '请选择分润类型', trigger: 'change' }
          ]
        },
        d_index:'',
        dialogRefund:false,
        formLabelWidth:200,
        startEndOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        isStudent:false,
        refundTypeList:[{id:1,name:'线下'},{id:2,name:'系统自动'}],
        addForm:{
          title:'',
          refund_amount:0,
          refund_type:'',
          formLabelWidth:200,
          refund_reason:'',
          add_time:'',
          company_name:'',
          type:'',
          deal_time:'',
          status:'',
          id:'',
          name:'',
          sex:'',
          mobile:'',
          relaction_id:'',
          birthday:''
        },
        relationList:[],

        drawer1:false,

        isCollapsed:true,

        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],

        formData:{},
        visible:false,
        title: '',

        searchForm:{
          start_end_date:'',
          start_end_date1:'',
          type_id:'',
          start_time:'',
          end_time:'',
          status:'',
          sex:"",
          keyword:'',
          proxy_sn:'',
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        },
        searchRules:{

        },
        currentPage:1,
        pageSize:10,
        tableLoadData:[],
        total:0,

        userRole: 'principal', // 从实际登录信息获取，示例值：'principal' 或 'teacher'
        // 校长视图数据
        allClasses: [
          { id: 1, name: '高三（1）班' },
          { id: 2, name: '高三（2）班' }
        ],
        selectedClass: null,
        // 教师视图数据
        currentClass: {
          id: 1,
          name: '高三（1）班'
        },

        // 公共数据
        students: [],
        searchKey: '',
        scoreDialogVisible: false,
        currentStudent: {
          scores: {
            chinese: 0,
            math: 0,
            english: 0
          }
        },
        paramsList:[]
      }
    },

    computed: {
      filteredStudents() {
        return this.students.filter(s =>
                s.name.includes(this.searchKey) ||
                s.studentId.includes(this.searchKey)
        )
      },
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      }
    },

    created() {
      this.DataList();
      this.getShopList(); // 获取商家列表
      this.getDicList('eduRelation');
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD ");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

    },
    methods: {

      // 获取商户分润参数列表
      async getShopBalanceParamsList() {
        if (!this.selectedShopInfo || !this.selectedShopInfo.id) {
          this.paramsList = [];
          return;
        }
        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            shop_id: this.selectedShopInfo.id
          };
          const res = await this.$axios.findShopBalanceParamsByShopList(params);
          if (res.code === 200 && res.data) {
            this.paramsList = res.data;
            // 如果有分润参数，可以根据需要设置默认类型
           // if (this.paramsList.length > 0) {
              // 这里可以添加逻辑来处理已存在的分润参数
              // 例如：检查是否已经存在某种类型的分润设置
              // const hasType1 = this.paramsList.some(item => item.type_id === 1);
              // const hasType2 = this.paramsList.some(item => item.type_id === 2);
              //
              // // 可以根据业务需求设置默认值或给出提示
              // if (hasType1 && hasType2) {
              //   // 两种类型都已存在
              //   this.$message.warning('该商户已设置两种分润类型');
              // }
            //}
          } else {
            this.paramsList = [];
          }
        } catch (error) {
          console.error('获取商户分润参数失败:', error);
          this.paramsList = [];
        }
      },
      // 远程搜索商户
      remoteSearchShop(query) {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }

        this.searchTimer = setTimeout(() => {
          this.doSearchShop(query);
        }, 300);
      },

      // 执行商户搜索
      async doSearchShop(keyword) {
        if (!keyword || keyword.trim() === '') {
          this.shopList = [];
          return;
        }

        this.shopLoading = true;

        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            keyword: keyword.trim(),
            pageNum: 1,
            pageSize: 20,
            fields: 'id,name,mobile,contact_phone,province,city,district,address,status,contact_person'
          };
          const res = await this.$axios.searchShopListP(params);

          if (res.code === 200) {
            this.shopList = res.data.data || [];
            this.searchConfig.hasMore = res.data.total > res.data.data.length;
          } else {
            this.shopList = [];
            this.$message.error(res.msg || '搜索失败');
          }
        } catch (error) {
          console.error('搜索商户失败:', error);
          this.shopList = [];
          this.$message.error('搜索失败，请重试');
        } finally {
          this.shopLoading = false;
        }
      },

      // 选择框获取焦点时处理
      handleShopFocus() {
        // 如果当前有选中值但列表为空，尝试搜索当前选中的商户
        if (this.form.shop_id && this.shopList.length === 0 && this.selectedShopInfo) {
          this.shopList = [this.selectedShopInfo];
        }
      },

      // 商户选择变化
      handleShopChange(shopId) {
         console.log('handleShopChange',shopId)
        if (!shopId) {
          this.selectedShopInfo = null;
          this.paramsList = []; // 清空分润参数列表
          return;
        }
        //
        // // 从当前列表中找到选中的商户信息
        const selectedShop = this.shopList.find(shop => shop.id === shopId);
        if (selectedShop) {
          console.log('selectedShop',selectedShop)
          this.selectedShopInfo = selectedShop;
          // 选择商户后立即获取该商户的分润参数列表
          this.getShopBalanceParamsList();
        } else {
          // 如果列表中没有，可能是初始值，需要单独查询
          this.fetchShopInfo(shopId);
        }
      },

      // 获取单个商户详情
      async fetchShopInfo(shopId) {
        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: shopId
          };

          const res = await this.$axios.findShopOne(params);

          if (res.code === 200 && res.data) {
            this.selectedShopInfo = res.data;
            // 如果当前列表为空，将查询到的商户添加到列表
            if (this.shopList.length === 0) {
              this.shopList = [res.data];
              // 获取商户详情后立即获取分润参数列表
              this.getShopBalanceParamsList();
            }
          }
        } catch (error) {
          console.error('获取商户详情失败:', error);
        }
      },

      // 编辑时初始化商户信息
      async initShopInfoForEdit(row) {
        // 如果存在shop_id，获取商户详情
        if (row.shop_id) {
          await this.fetchShopInfo(row.shop_id);
          this.getShopBalanceParamsList();
        }

        this.dialogTitle = '编辑分润设置';
        this.form = {
          id: row.id,
          shop_id: row.shop_id,
          name: row.name,
          rate: row.rate,
          type_id: row.type_id,
          balance_params_id: row.balance_params_id,
          proxy_sn: row.proxy_sn,
          status: row.status,
          remark: row.remark || ''
        };



        this.dialogVisible = true;

        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate();
          }
        });
      },
      // 获取商家列表
      async getShopList() {
        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            pageSize: 1000 // 获取所有商家

          };

          const res = await this.$axios.shopByShopListP(params);
          if (res.code === 200) {
            this.shopList = res.data.data || [];
          }
        } catch (error) {
          console.error('获取商家列表失败:', error);
          this.$message.error('获取商家列表失败');
        }
      },

      // 新增分润设置
      goAdd() {
        this.dialogTitle = '新增分润设置';
        this.form = {
          id: '',
          shop_id: '',
          name: '',
          rate: '',
          //type_id: 1,
          status: 1,
          remark: ''
        };
        this.dialogVisible = true;

        // 清除表单验证
        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate();
          }
        });
      },

      // 编辑分润设置
      async goEdit(row) {
        await this.initShopInfoForEdit(row);
      },
      // 提交表单
      submitForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) {
            this.$message.warning('请完善表单信息');
            return;
          }

          this.submitLoading = true;

          try {
            if(this.paramsList.length>0){
              let it=this.paramsList.find(item=>item.id==this.form.balance_params_id);
              this.form.type_id=it.type_id;
            }else{
              this.$message.warning('分润设置错误');
              return;
            }
            const params = {
              ...this.form,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            };

            let res;
            if (this.form.id) {
              // 编辑
              res = await this.$axios.ShopBalanceSetUpdate(params);
            } else {
              // 新增
              res = await this.$axios.ShopBalanceSetSave(params);
            }

            if (res.code === 200) {
              this.$message.success(res.msg || '操作成功');
              this.dialogVisible = false;
              this.DataList(); // 刷新列表
            } else {
              this.$message.error(res.msg || '操作失败');
            }
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败，请重试');
          } finally {
            this.submitLoading = false;
          }
        });
      },

      // 删除分润设置
      goDelete(row) {
        this.$confirm('此操作将删除该分润设置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const params = {
              id: row.id,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            };

            const res = await this.$axios.deleteShopBalanceSet(params);

            if (res.code === 200) {
              this.$message.success(res.msg || '删除成功');
              this.total=0;
              this.currentPage=1;
              this.DataList(); // 刷新列表
            } else {
              this.$message.error(res.msg || '删除失败');
            }
          } catch (error) {
            console.error('删除失败:', error);
            this.$message.error('删除失败，请重试');
          }
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      // 批量删除
      batchDelete() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要删除的数据');
          return;
        }

        this.$confirm(`此操作将删除选中的 ${this.multipleSelection.length} 条分润设置, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const ids = this.multipleSelection.map(item => item.id);
            const params = {
              ids: ids.join(','),
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            };

            const res = await this.$axios.batchDeleteShopBalanceParams(params);

            if (res.code === 200) {
              this.$message.success(res.msg || '批量删除成功');
              this.multipleSelection = [];
              this.DataList(); // 刷新列表
            } else {
              this.$message.error(res.msg || '批量删除失败');
            }
          } catch (error) {
            console.error('批量删除失败:', error);
            this.$message.error('批量删除失败，请重试');
          }
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
        this.submitLoading = false;
      },


      // 导出Excel
      async goExcel() {
        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            ...this.searchForm
          };

          // 移除分页参数
          delete params.pageNum;
          delete params.pageSize;

          const res = await this.$axios.exportShopBalanceParams(params);

          if (res.code === 200) {
            // 假设接口返回文件下载地址
            if (res.data.download_url) {
              window.open(res.data.download_url);
            } else {
              this.$message.success('导出成功');
            }
          } else {
            this.$message.error(res.msg || '导出失败');
          }
        } catch (error) {
          console.error('导出失败:', error);
          this.$message.error('导出失败，请重试');
        }
      },
      indexMethod(index) {
        return (this.currentPage - 1) * this.pageSize + index + 1
      },

      goDetail(item){
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          tax_id: item.id,
        }
        this.$axios.taxLeshuaQuery(param).then(res => {
          if (res.code != 200) {
            this.$message.error(res.msg);
          }
        })
      },
      handleRefundClick(val){
        if(this.addForm.refund_type===val){
          this.addForm.refund_type=null;
        }else{
          this.addForm.refund_type=val;
        }
      },
      goRefundSave(){

        let _this=this;
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          tax_id: _this.addForm.id,
          refund_reason:_this.addForm.refund_reason,
          refund_amount:_this.addForm.refund_amount
        }
        if(this.addForm.refund_type==2){
          this.$axios.taxLeshuaRefund(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.pageNum = 1;
              this.total = 0;
              this.tableLoadData = [];
              this.DataList()
            } else {
              this.$message.error(res.msg);
            }
          })
        }else  if(this.addForm.refund_type==1){
          this.$axios.taxRefund(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.pageNum = 1;
              this.total = 0;
              this.tableLoadData = [];
              this.DataList()
            } else {
              this.$message.error(res.msg);
            }
          })
        }



      },
      goRefund(e) {
        let _this=this;
        this.$confirm('此操作将把订单退款, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.addForm.id=e.id;
          _this.addForm.refund_amount=e.order_amount;
          _this.dialogRefund=true;

        }).catch(action => {

          if (action === 'cancel') {
            this.$message({
              type: 'info',
              message: '取消操作'
            });
          }
        });

      },
      goDel(item) {
        this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          console.log(item)
          // const param = {
          //   id:item.id,
          //   company_id:sessionStorage.getItem('company_id'),
          //   access_token:sessionStorage.getItem('token'),
          // }
          // this.$axios.demandDel(param).then(res=>{
          //   if(res.code == 200){
          //     this.$message.success(res.msg);
          //     this.total=0;
          //     this.tableLoadData=[];
          //     this.currentPage=1;
          //     this.DataList()
          //   }else{
          //     this.$message.error(res.msg);
          //   }
          // }).catch(error=>{
          //   console.log(error);
          // })


        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });

        });
        this.teamDialog = false
      },
      statusChange(){
        this.goSearch();
      },
      changeTime(){
        this.goSearch();
      },
      changeTime1(){
        this.goSearch();
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

      goSearch(){
        this.currentPage=1;
        this.tableLoadData=[];
        this.total=0;
        this.DataList();
      },
      getDicList(code){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:code,
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            if(code=='eduRelation'){
              this.relationList =res.data;
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });
      },
      submit() {
        let _this=this;
        let params={
          id:_this.addForm.id,
          deal_time:_this.addForm.deal_time,
          status:_this.addForm.status,
        };
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');

        this.$axios.demandDeal(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");

            this.tableLoadData[this.d_index].status=_this.addForm.status;
            this.drawer1=false;
          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.studentList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },

      closeForm() {
        this.title = "";
        this.visible = false;
        this.currentPage=1;
        this.DataList()
      },
      DataList(){
        let _this=this;
        const param = {
          company_id:_this.searchForm.company_id,
          access_token:_this.searchForm.access_token,
          proxy_id:_this.searchForm.proxy_id,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }

        if(this.searchForm.start_end_date){
          const [start_date,end_date]=this.searchForm.start_end_date;
          param.start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(this.searchForm.start_end_date1){
          const [start_date,end_date]=this.searchForm.start_end_date1;
          param.pay_start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.pay_end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(!isNaN(this.searchForm.status)){
          param.status=this.searchForm.status;
        }
        if(!isNaN(this.searchForm.type_id)){
          param.type_id=this.searchForm.type_id;
        }
        if(this.searchForm.proxy_sn){
          param.proxy_sn=this.searchForm.proxy_sn;
        }
        if(this.searchForm.keyword){
          param.keyword=this.searchForm.keyword;
        }
        param.order='shop_id asc,type_id asc';
        this.$axios.findShopBalanceSetListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.currentPage = 1;
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.currentPage = newPage
        this.DataList()
      },
      goInfo(row){
        this.$router.push({
          path:'/courseInfo',
          query:{
            id:row.id
          }
        })
      },

      async loadStudents() {
        // 根据角色调用不同API
        const apiUrl = this.userRole === 'principal'
                ? `/api/students?classId=${this.selectedClass}`
                : '/api/my-class/students'

        try {
          const res = await this.$axios.get(apiUrl)
          this.students = res.data
        } catch (error) {
          this.$message.error('数据加载失败')
        }
      },
      removeExtraZeros(num) {
        if(!isNaN(num)&&num!=null){
          return num.replace(/\.?0+$/, '');
        }else{
          return '';
        }

      },
      handleSearch() {
        // 防抖处理可根据需要添加
      },

      showScoreDialog(student) {
        this.currentStudent = JSON.parse(JSON.stringify(student))
        this.scoreDialogVisible = true
      },

      async saveScores() {
        try {
          await this.$axios.put(`/api/students/${this.currentStudent.id}/scores`,
                  this.currentStudent.scores
          )
          this.$message.success('成绩保存成功')
          this.scoreDialogVisible = false
          this.loadStudents()
        } catch (error) {
          this.$message.error('保存失败')
        }
      },
      // 重置搜索条件
      resetSearch() {
        this.searchForm = {
          start_end_date: '',
          type_id: '',
          status: '',
          company_name: '',
          proxy_id: sessionStorage.getItem('proxy_id'),
          shop_id: sessionStorage.getItem('shop_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.currentPage = 1;
        this.DataList();
      },
    }
  }
</script>

<style scoped>

  .filter-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .class-info {
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .class-info h3 {
    margin: 0 0 10px 0;
    color: #303133;
  }

  .detail-info p {
    margin: 8px 0;
    font-size: 14px;
  }


  .condition-content {
    padding-top: 15px;
  }

  /* 过渡动画优化 */
  .el-collapse-transition {
    transition: 0.3s height ease-in-out, 0.3s padding-top ease-in-out;
  }

  /* 表单元素间距调整 */
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  /* 操作按钮间距 */
  .el-button--mini {
    margin: 2px;
  }

  /* 状态标签样式 */
  .el-tag {
    margin: 2px;
  }

  /* 表单验证样式 */
  .el-form-item__error {
    padding-top: 2px;
  }

  /* 表格操作列固定 */
  .el-table__fixed-right {
    height: 100% !important;
  }

  /* 商户选项样式 */
  .shop-option {
    padding: 8px 12px;
    line-height: 1.4;
  }

  .shop-main-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }

  .shop-name {
    font-weight: 600;
    color: #303133;
    flex: 1;
    margin-right: 8px;
  }

  .shop-detail-info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;
  }

  .shop-region,
  .shop-mobile {
    flex: 1;
  }

  .shop-address {
    font-size: 12px;
    color: #909399;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .shop-address i,
  .shop-region i,
  .shop-mobile i {
    margin-right: 4px;
    color: #c0c4cc;
  }

  /* 选中商户信息样式 */
  .selected-shop-info {
    border-radius: 4px;
  }

  .selected-shop-content {
    padding: 8px;
  }

  .selected-shop-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .selected-shop-name {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
  }

  .selected-shop-details {
    font-size: 12px;
    color: #606266;
  }

  .detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .detail-item i {
    margin-right: 8px;
    color: #909399;
    width: 16px;
    text-align: center;
  }

  .detail-item:last-child {
    margin-bottom: 0;
  }

  /* 空状态样式 */
  .empty-shop {
    padding: 20px 0;
    text-align: center;
    color: #909399;
  }

  /* 下拉菜单样式优化 */
  .el-select-dropdown .el-select-dropdown__item {
    height: auto;
    padding: 8px 12px;
    line-height: 1.4;
  }

  .el-select-dropdown .el-select-dropdown__item.hover,
  .el-select-dropdown .el-select-dropdown__item:hover {
    background-color: #f5f7fa;
  }

  /* 响应式适配 */
  @media (max-width: 768px) {
    .shop-detail-info {
      flex-direction: column;
    }

    .shop-region,
    .shop-mobile {
      margin-bottom: 2px;
    }
  }

  /* 查询条件容器 */
  .search-container {
    background: #f8f9fa;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 16px;
    border: 1px solid #e9ecef;
  }

  /* 查询头部 */
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .search-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #343a40;
    font-size: 14px;
  }

  .search-title i {
    margin-right: 6px;
    color: #409EFF;
  }

  /* 切换按钮 */
  .toggle-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #6c757d;
    font-size: 13px;
    transition: color 0.3s;
  }

  .toggle-button:hover {
    color: #409EFF;
  }

  .toggle-button i {
    margin-left: 4px;
    font-size: 12px;
  }

  /* 查询内容区域 */
  .search-content {
    background: white;
    border-radius: 4px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  /* 表单样式 */
  .search-form {
    width: 100%;
  }

  .form-item-custom {
    margin-bottom: 0;
    width: 100%;
  }

  .search-input,
  .search-select {
    width: 100%;
  }

  .date-picker {
    width: 100%;
  }

  /* 查询操作区域 */
  .search-actions {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 28px;
  }

  .search-btn,
  .reset-btn {
    min-width: 80px;
  }

  /* 操作按钮区域 */
  .action-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    margin-bottom: 16px;
    border-bottom: 1px solid #e9ecef;
  }

  .action-buttons {
    display: flex;
    gap: 8px;
  }

  .selection-info {
    display: flex;
    align-items: center;
  }

  /* 表格样式 */
  .data-table {
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }

  /* 分页样式 */
  .pagination {
    margin-top: 20px;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .search-container {
      padding: 12px;
    }

    .search-content {
      padding: 12px;
    }

    .el-col {
      margin-bottom: 12px;
    }

    .search-actions {
      padding-top: 0;
      justify-content: flex-start;
    }

    .action-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }

  /* 动画效果 */
  .el-collapse-transition {
    transition: all 0.3s ease-in-out;
  }

  /* 表单元素聚焦效果 */
  .search-input :deep(.el-input__inner:focus),
  .search-select :deep(.el-input__inner:focus) {
    border-color: #409EFF;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  /* 按钮悬停效果 */
  .search-btn:hover,
  .reset-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  /* 卡片阴影优化 */
  .box-card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: none;
  }
</style>
